// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer___19iEh"};